<template>
    <el-dialog
            title="表单添加/编辑"
            :visible.sync="dialogVisible"
            width="500px"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            append-to-body>
        <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="字段名">
                <el-input v-model="form.name" placeholder="请输入字段名" clearable></el-input>
            </el-form-item>
            <el-form-item label="字段类型">
                <el-select v-model="form.type" placeholder="请选择字段类型" clearable>
                    <el-option
                            v-for="item in typeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="字段限制">
                <el-input v-model="form.ruleConfig" v-if="this.form.type === 2" placeholder="请输入选项，用逗号“，”隔开" clearable></el-input>
                <el-input v-model="form.ruleConfig" v-else-if="this.form.type === 3" placeholder="按身份证规则输入" clearable></el-input>
                <el-input v-model="form.ruleConfig" v-else-if="this.form.type === 4" placeholder="请输入数字长度" clearable></el-input>
                <el-input v-model="form.ruleConfig" v-else-if="this.form.type === 5" placeholder="可上传图片格式文件" clearable></el-input>
                <el-input v-model="form.ruleConfig" v-else-if="this.form.type === 6" placeholder="可上传各类格式文件" clearable></el-input>
                <el-input v-model="form.ruleConfig" v-else-if="this.form.type === 8" placeholder="请输入编号长度与名称长度，用逗号“，”隔开" clearable></el-input>
                <el-input v-model="form.ruleConfig" v-else placeholder="请填入长度限制、列表规则，或不限制" clearable></el-input>
            </el-form-item>
            <el-form-item label="是否必填">
                <el-radio v-model="form.required" :label="0">否</el-radio>
                <el-radio v-model="form.required" :label="1">是</el-radio>
            </el-form-item>
            <el-form-item label="字段说明">
                <el-input v-model="form.note" type="textarea" placeholder="请输入字段说明" :rows="4" clearable></el-input>
            </el-form-item>
        </el-form>
        <div class="flex-middle flex-center">
            <el-button plain @click="resetForm">重置</el-button>
            <el-button plain @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submit">保存</el-button>
        </div>
    </el-dialog>
</template>

<script type="text/javascript">
    import Utils from "../../../assets/js/Utils";

    export default {
        name: 'AddFormDialog',
        props: ['successCallback'],
        data() {
            return {
                dialogVisible: false,
                allowAction: [],
                formId: null,
                form: {
                    id: null,
                    name: null,
                    type: null,
                    ruleConfig: null,
                    note: null,
                    required: 0,
                },
                typeList: [{label:'文本',value:1},{label:'选项',value:2},{label:'身份证',value:3},{label:'数字',value:4},
                    {label:'电话',value:5},{label:'图片',value:6},{label:'文件',value:7},{label:'编号与名称',value:8}],
            }
        },
        watch: {
            dialogVisible(newVal, oldVal) {
                if (newVal == false) {
                    Object.assign(this.$data, this.$options.data())
                }
            }
        },
        methods: {

            // 显示弹出层
            setMaskVisible(val, data) {
                this.dialogVisible = val
                this.allowAction = Utils.checkMenuOprate('enroll.form')
                this.form  = Object.assign({},data)
                this.formId = this.form.id
            },

            resetForm() {
                this.form = {}
                this.form.id = this.formId
            },

            submit() {
                let url = Urls.URL.form_url
                let params = {}
                if(this.formId) {
                    url = url + '/' + this.formId
                }
                params.name = this.form.name
                params.type = this.form.type
                params.ruleConfig = this.form.ruleConfig
                params.note = this.form.note
                params.required = this.form.required
                axios.post(url,params).then(res => {
                    this.dialogVisible = false
                    this.$emit('fetchData')
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

        }
    }
</script>

<style scoped lang="stylus">
    .dec-bc-style {
        flex: 1
        background-color: #F5F5F5
        >label {
            display inline-block
            margin-left 15px
        }
    }

    /deep/.el-select {
        width 100%
    }
</style>
